/**
 * @desc getItemBuybox
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getItemBuybox.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getItemBuybox`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
